import React from 'react';
import { Link } from 'react-router-dom';

const VerifyEmail = () => {

  return (
    <div className="flexbox column" id="verify-email-box">
      <div className="align-center" style={{ minHeight: '50vh' }}>
        <img src="assets/img/1-edgeway_logo_rgb.png" alt="loginlogo.png" className="margin-bottom-small" id="edgeWayLogo" />
        <h1>Verify your email before login</h1>
        <h2 className="margin-bottom-large">
        An link has sent to your email,
          <br />
        Please click the link to completed the signup.
        </h2>
        <Link style={{ marginLeft: '4px' }} to="/login">
        Log in
        </Link>
      </div>
    </div>
  );

};

export default VerifyEmail;